/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import { connect } from 'react-redux';

import { planningDetailsUrl } from 'services/Externals';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import { SendTo } from 'App';

const PlanningDetailsRedirect = ({ isCustomerWebView }) => {
  SendTo({ target: planningDetailsUrl(isCustomerWebView) });
  return null;
};

const mapStateToProps = (state) => ({
  isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(PlanningDetailsRedirect);
